export const glossaryData = [
  // Left Side Items
  {
    id: 'a',
    title: 'Retribuzione',
    side: 'left',
    angle: -90, // Defines where the knob points (-90 is left horizontal)
    text: 'Il salario o lo stipendio di base e tutte le somme e i valori versati dal datore di lavoro, direttamente o indirettamente, anche in natura, al lavoratore in relazione al rapporto di lavoro, ivi comprese le componenti complementari o variabili.'
  },
  {
    id: 'b',
    title: 'Livello retributivo',
    side: 'left',
    angle: -75,
    text: "La retribuzione lorda annua e la corrispondente retribuzione oraria lorda, da intendersi come la totalità degli elementi retributivi continuativi e fissi, ad esclusione dei trattamenti economici individuali non strutturali quali componenti retributive riconosciute su base personale, discrezionale o temporanea non generalizzate all'interno della medesima categoria di lavoratori e fondate su criteri oggettivi individuali."
  },
  {
    id: 'c',
    title: 'Divario di genere',
    side: 'left',
    angle: -60,
    text: 'La differenza tra i livelli retributivi medi corrisposti da un datore di lavoro ai lavoratori di sesso femminile e a quelli di sesso maschile, espressa in percentuale del livello retributivo medio dei lavoratori di sesso maschile.'
  },
  {
    id: 'd',
    title: 'Livello mediano',
    side: 'left',
    angle: -45,
    text: "Il livello retributivo rispetto al quale una metà dei lavoratori di un datore di lavoro guadagna di più e l'altra metà guadagna di meno."
  },
  {
    id: 'e',
    title: 'Divario mediano',
    side: 'left',
    angle: -30,
    text: 'La differenza tra il livello retributivo mediano dei lavoratori di sesso femminile e il livello retributivo mediano dei lavoratori di sesso maschile di un datore di lavoro, espressa in percentuale del livello retributivo mediano dei lavoratori di sesso maschile.'
  },
  {
    id: 'f',
    title: 'Quartile retributivo',
    side: 'left',
    angle: -15,
    text: 'Ciascuno dei quattro gruppi uguali in cui i lavoratori sono suddivisi in base al loro livello retributivo, dal più basso al più elevato.'
  },
  {
    id: 'g',
    title: 'Pari valore',
    side: 'left',
    angle: 0, // 0 is straight up
    text: 'Il lavoro ritenuto di pari valore secondo i criteri non discriminatori, oggettivi e neutri sotto il profilo del genere di cui all\'articolo 4 del presente decreto.'
  },

  // Right Side Items
  {
    id: 'h',
    title: 'Categoria lavoratori',
    side: 'right',
    angle: 25,
    text: "L'insieme di lavoratori e lavoratrici che svolgono lo stesso lavoro o lavori considerati di pari valore, ai sensi dell'articolo 4 del presente decreto."
  },
  {
    id: 'i',
    title: 'Discrim. diretta',
    side: 'right',
    angle: 40,
    text: 'La discriminazione di cui agli articoli 25, commi 1 e 2-bis, e 26 del codice delle pari opportunità tra uomo e donna, di cui al decreto legislativo 11 aprile 2006, n. 198.'
  },
  {
    id: 'l',
    title: 'Discrim. indiretta',
    side: 'right',
    angle: 55,
    text: 'La discriminazione di cui agli articoli 25, commi 2 e 2-bis, e 26 del codice di cui al decreto legislativo n. 198 del 2006.'
  },
  {
    id: 'm',
    title: 'Intersezionale',
    side: 'right',
    angle: 70,
    text: "La discriminazione originata dalla combinazione della discriminazione fondata sul genere con quella derivante da altri fattori di discriminazione, quali la razza, l'origine etnica, la religione, le convinzioni personali, la disabilità, l'età o l'orientamento sessuale, di cui ai decreti legislativi 9 luglio 2003, n. 215 e n. 216, all'articolo 15 della legge 20 maggio 1970, n. 300, e agli articoli 43 e 44 del decreto legislativo 25 luglio 1998, n. 286."
  },
  {
    id: 'n',
    title: 'Organismo parità',
    side: 'right',
    angle: 85,
    text: 'Le consigliere e i consiglieri di parità di cui al libro I, titolo II, capo IV, del codice di cui al decreto legislativo n. 198 del 2006.'
  },
  {
    id: 'o',
    title: 'Rappresentanti',
    side: 'right',
    angle: 100,
    text: 'I componenti delle rappresentanze sindacali unitarie (RSU), delle rappresentanze sindacali aziendali (RSA) o, in assenza di queste, i rappresentanti territoriali delle organizzazioni sindacali firmatarie del contratto collettivo nazionale di lavoro (CCNL) applicato in azienda e i soggetti a cui i lavoratori possano legalmente conferire specifico mandato.'
  }
];